<template>
  <nav class="tab-bar">
    <router-link
      to="/finance"
      class="tab-bar__item"
      active-class="active"
      exact
      >{{ $t("overview") }}</router-link
    >
    <router-link
      to="/finance/securities"
      class="tab-bar__item"
      active-class="active"
      exact
      >{{ $t("securities") }}</router-link
    >
    <router-link
      to="/finance/cash"
      class="tab-bar__item"
      active-class="active"
      exact
      >{{ $t("cash") }}</router-link
    >
    <router-link
      to="/finance/debts"
      class="tab-bar__item"
      active-class="active"
      exact
      >{{ $t("debts") }}</router-link
    >
    <router-link
      to="/finance/transactions"
      class="tab-bar__item"
      active-class="active"
      exact
      >{{ $t("transactions") }}</router-link
    >
    <!-- Данная функциональность еще не реализована. Элемент закоментирован перед презентацией -->
    <!-- <router-link
      to="/finance/analysis"
      class="tab-bar__item"
      active-class="active"
      exact
      >{{ $t("analysis") }}</router-link
    > -->
  </nav>
</template>

<script>
export default {};
</script>

<style scoped>
.tab-bar {
  height: 53px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #dfe1e5;
  box-sizing: border-box;
}

.tab-bar__item {
  height: 100%;
  padding: 0 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 17px;
  color: #212121;
  text-decoration: none;
  border-bottom: 3px solid transparent;
  box-sizing: border-box;
}

.tab-bar__item.active {
  border-bottom: 3px solid #2e79ef;
}

.tab-bar__item:first-child {
  margin-left: 25px;
}

.tab-bar__item:not(:first-child) {
  margin-left: 60px;
}

@media (max-width: 600px) {
  .tab-bar {
    justify-content: space-around;
  }

  .tab-bar__item {
    font-size: 15px;
  }

  .tab-bar__item:first-child {
    margin-left: 0;
  }

  .tab-bar__item:not(:first-child) {
    margin-left: 0;
  }
}
</style>
